export const ownerVerifiedContent = {
  professionalName: '[CONFIRMAR: nome público do profissional]',
  professionalRole: '[CONFIRMAR: título e escopo de atuação autorizados]',
  companyName: '[CONFIRMAR: razão social ou nome empresarial, se aplicável]',
  cnpj: '[CONFIRMAR: CNPJ, se aplicável e se deve ser exibido]',
  ancordCredential: '[CONFIRMAR: número, categoria, validade e URL oficial verificável]',
  ademiconRelationship: '[CONFIRMAR: vínculo, cargo, autorização e URL oficial verificável]',
  bcbStatement: '[CONFIRMAR: texto jurídico aprovado sobre regulação e responsabilidade]',
  portfolioValue: '[CONFIRMAR: valor, data-base, definição de carteira e evidência]',
  clientCount: '[CONFIRMAR: contagem, data-base, definição de cliente/investidor e evidência]',
  technologyExperience: '[CONFIRMAR: período e fonte da experiência profissional]',
  salesClaim: '[NÃO PUBLICAR SEM EVIDÊNCIA E REVISÃO JURÍDICA]',
  testimonial: '[CONFIRMAR: autorização, nome/abreviação, contexto, data e evidência]',
  administrators: '[CONFIRMAR: administradoras, autorização e relação econômica]',
  compensationModel: '[CONFIRMAR: comissão, indicação, honorários, parcerias e conflitos]',
  privacyPolicyUrl: '[CONFIRMAR: URL publicada e revisada]',
  termsUrl: '[CONFIRMAR: URL publicada, se aplicável]',
  supportEmail: '[CONFIRMAR: e-mail responsável pelo atendimento e privacidade]'
};
